import React, { forwardRef } from 'react';
import styles from './StyleConstants.module.css';

const cx = (base: string, extra?: string) =>
  extra ? `${base} ${extra}` : base;

export const H2 = forwardRef<
  HTMLHeadingElement,
  React.ComponentPropsWithoutRef<'h2'>
>(({ className, ...rest }, ref) => (
  <h2 ref={ref} className={cx(styles.h2, className)} {...rest} />
));
H2.displayName = 'H2';

export const P = forwardRef<
  HTMLParagraphElement,
  React.ComponentPropsWithoutRef<'p'>
>(({ className, ...rest }, ref) => (
  <p ref={ref} className={cx(styles.p, className)} {...rest} />
));
P.displayName = 'P';
